<div class="categorization-view manual-item-view">
  <h3 class="manual-item-title">Manual Item</h3>
  <p class="manual-item-subheader">Add a custom line item with manual data entry</p>
  <div class="manual-item-actions">
    <button type="button" class="btn btn-primary" (click)="onInsertItem()">Insert Item</button>
  </div>
</div>
